export function FormsPortalTabsPanel({ activeTab = 'all', tabCounts = {}, onTabChange }) {
  const tabs = [
    { id: 'all', label: 'All Forms', count: tabCounts.all },
    { id: 'general', label: 'General Forms', count: tabCounts.general },
    { id: 'fms', label: 'FMS Forms', count: tabCounts.fms }
  ];

  return (
    <article className="migration-panel migration-panel--full forms-portal-tabs-card" style={{ marginBottom: '16px' }}>
      <div className="fms-tabs-row">
        {tabs.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`attendance-tab${activeTab === item.id ? ' attendance-tab--active' : ''}`}
            onClick={() => onTabChange(item.id)}
          >
            {item.label}
            <span className="fms-tab-count">{item.count ?? 0}</span>
          </button>
        ))}
      </div>
    </article>
  );
}
